// extracted by mini-css-extract-plugin
export default {"wrap":"wrap__784af148","title_wrapper":"title_wrapper__784af148","title":"title__784af148","control_panel":"control_panel__784af148","creators":"creators__784af148"};